import * as yup from 'yup';

const roleSchema = yup.object().shape({
  name: yup.string().required('common.required'),
  permissions: yup.array().of(
    yup.object().shape({
      value: yup.string(),
      label: yup.string(),
    }),
  ).nullable().required('common.required'),
});

export default roleSchema;
